module.exports = __webpack_public_path__ + "static/poison_mtg_clb-04a94d55216a598b27c9ab355fcd32fa.jpg";